import lightTheme from "../../utils/styles";
import React, { useState, useEffect } from 'react';

const LoadingBar = ({ progress, isMarginBottom }) => {
    const [animatedProgress, setAnimatedProgress] = useState(0);

    useEffect(() => {
        // Cap the target progress at 99%
        const cappedProgress = Math.min(progress, 99);
        
        // Calculate the difference between current animated progress and new target
        const progressDifference = cappedProgress - animatedProgress;
        
        // Only use "minus 6" logic if the jump is significant (more than 6%)
        // Otherwise, animate from current position
        let startProgress;
        if (progressDifference > 6) {
            startProgress = Math.max(0, cappedProgress - 6);
        } else {
            startProgress = animatedProgress;
        }
        
        setAnimatedProgress(startProgress);

        // If we need to animate up to the target progress
        if (startProgress < cappedProgress) {
            let timeoutId;
            
            const animateStep = () => {
                setAnimatedProgress(current => {
                    const next = current + 1;
                    if (next >= cappedProgress) {
                        return cappedProgress;
                    } else {
                        // Schedule next step with random delay between 0.4 and 0.9 seconds
                        const randomDelay = Math.random() * 700 + 400; // 400-1100ms
                        timeoutId = setTimeout(animateStep, randomDelay);
                    }
                    return next;
                });
            };
            
            // Start the first step with initial random delay
            const initialDelay = Math.random() * 700 + 400;
            timeoutId = setTimeout(animateStep, initialDelay);

            // Cleanup function to clear timeout if component unmounts or progress changes
            return () => clearTimeout(timeoutId);
        }
    }, [progress]);

    const barStyle = {
        width: `${animatedProgress}%`,
        height: '50px',
        backgroundColor: '#fb923c',
        transition: 'width 0.5s',
        borderRadius: '10px',
        display: 'flex', // Use flexbox to center the text
        alignItems: 'center', // Center the text vertically
        justifyContent: 'center', // Center the text horizontally
        color: 'white', // Set text color to white
        position: 'relative', // Position relative to the container
        overflow: 'hidden', // Prevent text from overflowing
        fontWeight: 'bold'
    };

    const containerStyle = {
        width: '100%',
        height: '50px',
        backgroundColor: lightTheme.colors.lightGray,
        borderRadius: '10px',
        marginBottom: isMarginBottom ? '4rem' : '0rem',
        overflow: 'hidden'
    };

    return (
        <div style={containerStyle}>
            <div style={barStyle}>
                {Math.round(animatedProgress)}%
            </div>
        </div>
    );
};

export default LoadingBar;
